import { useContext, useEffect, useState } from 'react';
import { Alert, Box, Button, Chip, Modal, ModalDialog, Stack, Typography } from '@mui/joy';
import { motion } from 'framer-motion';
import { LayoutContext } from '../context';
import { APIGetPrograms, APIUpdateMyProfile } from '../api';

export function DrawingProgramsPicker({ value = [], onChange, disabled = false }) {
  const [options, setOptions] = useState([]), [error, setError] = useState(''), [busy, setBusy] = useState(false);
  async function load() {
    setBusy(true); setError('');
    try {
      const data = await APIGetPrograms();
      const rows = Array.isArray(data) ? data : data?.results;
      if (!Array.isArray(rows) || !rows.length) throw new Error('Список программ пуст или недоступен. Обратитесь к менеджеру.');
      setOptions(rows);
    } catch (e) { setError(e.message || 'Не удалось загрузить программы'); }
    finally { setBusy(false); }
  }
  useEffect(() => { load(); }, []);
  const ids = value.map(Number);
  return <Stack spacing={1}>
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {options.map(p => <Chip key={p.id} disabled={disabled}
        slotProps={{ action: { 'aria-pressed': ids.includes(Number(p.id)) } }} variant={ids.includes(Number(p.id)) ? 'solid' : 'outlined'}
        color="primary" onClick={() => onChange(ids.includes(Number(p.id)) ? ids.filter(id => id !== Number(p.id)) : [...ids, Number(p.id)])}>
        {p.name}
      </Chip>)}
    </Box>
    {busy && <Typography level="body-sm">Загружаем программы…</Typography>}
    {error && <Alert color="warning">{error}<Button size="sm" variant="plain" onClick={load}>Повторить</Button></Alert>}
  </Stack>;
}

export default function DrawingProgramsDialog() {
  const { account, setAccount, tokenEmployee } = useContext(LayoutContext);
  const [ids, setIds] = useState([]), [busy, setBusy] = useState(false), [error, setError] = useState('');
  const open = !!account?.id && account?.position?.includes('draftsman') && !account?.drawing_programs?.length;
  useEffect(() => { setIds([]); setError(''); }, [account?.id, open]);
  async function save() {
    if (!ids.length || busy) return;
    setBusy(true); setError('');
    try {
      const result = await APIUpdateMyProfile({ drawing_program_ids: ids }, tokenEmployee);
      if (result?.status !== 'ok' || !result?.employee?.drawing_programs?.length) throw new Error(result?.message || 'Не удалось сохранить программы');
      setAccount(prev => ({ ...prev, drawing_programs: result.employee.drawing_programs }));
    } catch (e) { setError(e.message); } finally { setBusy(false); }
  }
  return <Modal open={open} sx={{ zIndex: 10150, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <ModalDialog component={motion.div} initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }}
      sx={{ position: 'relative', top: 'auto', left: 'auto', transform: 'none', width: 460, maxWidth: 'calc(100vw - 24px)', maxHeight: '90dvh', overflowY: 'auto', borderRadius: 'xl' }}>
      <Typography level="h4">На каких программах вы работаете?</Typography>
      <Typography level="body-sm">Выберите хотя бы одну программу, чтобы менеджеры могли подбирать вам подходящие чертежи. Список можно изменить в профиле.</Typography>
      <DrawingProgramsPicker value={ids} onChange={setIds} disabled={busy} />
      {error && <Alert color="danger">{error}</Alert>}
      <Button loading={busy} disabled={!ids.length} onClick={save}>Сохранить и продолжить</Button>
    </ModalDialog>
  </Modal>;
}
